<template>
  <DialogLayout
    :title="title"
    :visible.sync="dialogVisible"
    width="45em"
    @open="open"
  >
    <template #form>
      <CheckDataForm
        ref="checkDataForm"
        v-model="checkDataFormModel"
        action="/check-merge-data"
        billingYmMode="this"
      />
    </template>
    <template #footer>
      <CheckDataDialogFooter
        buttonCaption="チェック"
        @create="clickCheckData"
      />
    </template>
 </DialogLayout>
</template>

<script>
import DialogLayout from '@/components/templates/DialogLayout.vue'
import CheckDataForm from '@/components/organisms/dialog/CreateForm.vue'
import CheckDataDialogFooter from '@/components/organisms/dialog/CreateDialogFooter.vue'

export default {
  components: {
    DialogLayout,
    CheckDataForm,
    CheckDataDialogFooter
  },
  mixins: [
  ],
  props: {
    visible: Boolean
  },
  data () {
    return {
      title: 'データチェック',
      checkDataFormModel: {
        billing_ym: this.getDefaultBillingYm()
      }
    }
  },
  computed: {
    dialogVisible: {
      get () {
        return this.visible
      },
      set (visible) {
        this.$emit('update:visible', visible)
      }
    }
  },
  mounted () {
  },
  methods: {
    async clickCheckData () {
      this.$loadingMask.on()
      const params = { ...this.checkDataFormModel }
      this.$refs.checkDataForm.validate()
        .then((valid) => {
          return this.$axios.put('/check-merge-data', params)
        })
        .then((res) => {
          if (res.status === 202) {
            this.$fcMessage.showMessage({
              id: 'DTM0002I',
              link: {
                fileName: 'チェック結果.txt',
                messages: res.data.message
              }
            }, true)
          } else {
            this.$fcMessage.showMessage(res.data.message)
          }
          this.dialogVisible = false
          this.$emit('refresh', this.checkDataFormModel.billing_ym)
        })
        .catch((e) => {
          if (e.response) {
            switch (e.response.status) {
              case 402:
                this.$fcMessage.showMessage(e.response.data.message)
                break
              default:
            }
          }
        })
        .finally(() => {
          this.$loadingMask.off()
        })
    },
    open () {
      console.log('MergeDataCheckDataDialog.open')
      this.$nextTick(function () {
        console.log(this.$refs.createForm)
        this.$refs.createForm.clear()
      })
    }
  }
}
</script>

<style lang="scss">
    // 実績年月の表示追加
    .el-form-item{
    white-space: nowrap;
  }
</style>
